import { Grid } from '@mui/material';
import { useRetrieveUserCredentials } from '../../../../../hooks/user/useRetrieveUserCredentials';
import { usePlanMapFilters } from '../../hooks/plan-details/usePlanMapFilters';
import { MapFiltersItem } from './MapFIltersItem';

import _ from 'lodash';
import { useMemo } from 'react';
import AlertFilterIcon from '../../../../../assets/img/map_filters/alertFilter.svg';
import ArrowFilterIcon from '../../../../../assets/img/map_filters/arrowFilter.svg';
import DarkFilterIcon from '../../../../../assets/img/map_filters/darkFilter.svg';
import RouteFilterIcon from '../../../../../assets/img/map_filters/routeFilter.svg';
import SatelliteFilterIcon from '../../../../../assets/img/map_filters/satelliteFilter.svg';
import ShowCompletedFilter from '../../../../../assets/img/map_filters/showCompletedFilter.svg';
import StopFilterIcon from '../../../../../assets/img/map_filters/stopFilter.svg';
import TrafficFilterIcon from '../../../../../assets/img/map_filters/trafficFilter.svg';
import ZonesFilterIcon from '../../../../../assets/img/map_filters/zoneFilter.svg';
import { useRetrieveActiveProject } from '../../../../../hooks/project/useRetrieveActiveProject';

export const FiltersPopoverContent = () => {
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { data: activeProject } = useRetrieveActiveProject();
  const { setMapFilters, mapFilters } = usePlanMapFilters();

  const symbolsFilters = mapFilters.symbols;
  const showGeofences = userCredentials?.subscription.test(`planner.geofences`) && activeProject?.geo_fences_enabled;

  const filters = useMemo(() => {
    return [
      <MapFiltersItem
        key={`stops_filter`}
        image={StopFilterIcon}
        intlId="map_options.filters.stops"
        active={symbolsFilters.markers}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            symbols: {
              ...symbolsFilters,
              markers: !symbolsFilters.markers,
            },
          });
        }}
      />,
      <MapFiltersItem
        key={`lines_filter`}
        image={RouteFilterIcon}
        intlId="map_options.filters.lines"
        active={symbolsFilters.lines}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            symbols: {
              ...symbolsFilters,
              lines: !symbolsFilters.lines,
            },
          });
        }}
      />,
      <MapFiltersItem
        key={`arrows_filter`}
        image={ArrowFilterIcon}
        intlId="map_options.filters.arrows"
        active={symbolsFilters.arrows}
        containerStyles={{}}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            symbols: {
              ...symbolsFilters,
              arrows: !symbolsFilters.arrows,
            },
          });
        }}
      />,
      <MapFiltersItem
        key={`alerts_filter`}
        image={AlertFilterIcon}
        intlId="map_options.filters.alerts"
        active={symbolsFilters.alerts}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            symbols: {
              ...symbolsFilters,
              alerts: !symbolsFilters.alerts,
            },
          });
        }}
      />,
      ...(showGeofences
        ? [
            <MapFiltersItem
              key={`zones_filter`}
              image={ZonesFilterIcon}
              intlId="map_options.filters.zones"
              active={symbolsFilters.zones}
              onClick={() => {
                setMapFilters({
                  ...mapFilters,
                  symbols: {
                    ...symbolsFilters,
                    zones: !symbolsFilters.zones,
                  },
                });
              }}
            />,
          ]
        : []),
      <MapFiltersItem
        key={`traffic_filter`}
        image={TrafficFilterIcon}
        intlId="map_options.filters.traffic"
        active={symbolsFilters.traffic}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            symbols: {
              ...symbolsFilters,
              traffic: !symbolsFilters.traffic,
            },
          });
        }}
      />,
      <MapFiltersItem
        key={`show_completed_stops_filter`}
        image={ShowCompletedFilter}
        intlId="map_options.filters.show_completed_stops"
        active={symbolsFilters.completed}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            symbols: {
              ...symbolsFilters,
              completed: !symbolsFilters.completed,
            },
          });
        }}
      />,
      <MapFiltersItem
        key={`satellite_filter`}
        image={SatelliteFilterIcon}
        intlId="map_options.filters.satellite"
        active={mapFilters.mapType === `hybrid`}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            mapType: mapFilters.mapType === `hybrid` ? `routal` : `hybrid`,
          });
        }}
      />,
      <MapFiltersItem
        key={`dark_mode_filter`}
        image={DarkFilterIcon}
        intlId="map_options.filters.dark_mode"
        active={mapFilters.mapType === `routal_dark`}
        onClick={() => {
          setMapFilters({
            ...mapFilters,
            mapType: mapFilters.mapType === `routal_dark` ? `routal` : `routal_dark`,
          });
        }}
      />,
    ];
  }, [mapFilters, setMapFilters, showGeofences, symbolsFilters]);

  return (
    <Grid container style={{ padding: `14px`, display: `flex`, justifyContent: `space-around`, height: `100%` }}>
      {filters}
      {filters.length % 3 !== 0 &&
        _.range(3 - (filters.length % 3)).map((i) => <MapFiltersItem key={`extra_${i}`} empty />)}
    </Grid>
  );
};
